export default "__VITE_ASSET__BIXJxrJ0__"